<template>
    <v-row no-gutters >
      <v-col  cols="12" sm="8" md="8"
        ><v-data-table
          class="pa-3 mb-3 oneline"
          :headers="headers"
          :items="products"
          mobile-breakpoint="1"
          :single-select="singleSelect"
          item-key="name"
          style="border-radius:4px ;border: 1px solid #E0E0E0;"
        >
          <template v-slot:top>
            <autocomplete-product
              v-model="newProduct"
              item-text="name"
              label="Tìm Sản Phẩm"
              @change="addNewProduct"
            ></autocomplete-product>
          </template>
          <template class="oneline"  v-slot:[`item.actions`]="{ item }">
            <v-icon medium @click="deleteProduct(item)">delete</v-icon>
          </template>
          <template class="oneline" v-slot:[`item.price`]="{ item }">
            <div class="text-right body-2 font-weight-black">
              {{ (item.price * item.quantity) | formatMoney }}
            </div>
          </template>
          <template class="oneline" v-slot:[`item.quantity`]="props">
            <v-edit-dialog
              :return-value.sync="props.item.quantity"
              large
              persistent
            >
              <div>{{ props.item.quantity }}</div>
              <template class="oneline" v-slot:input>
                <div class="mt-4 title">Update Iron</div>
              </template>
              <template class="oneline" v-slot:[`input`]>
                <v-text-field
                  class="oneline"
                  v-model="props.item.quantity"
                  label="Edit"
                  single-line
                  type="number"
                  autofocus
                ></v-text-field>
              </template>
            </v-edit-dialog>
          </template> </v-data-table
      ></v-col>
      <v-col cols="12" sm="4" md="4"
        ><div style="background: #fff,border-radius:4px ;border: 1px solid #E0E0E0;">
          <lead
            ref="form"
            class="pa-3"
            v-if="lead"
            :lead="lead"
            :products="products"

          ></lead>
          <div class="text-end">
            <v-btn
              color="primary"
              large
              depressed
              class="mb-2 mr-3"
              @click="save()"
              :loading="loading"
            >
              TẠO / LƯU ĐƠN
            </v-btn>
          </div>
        </div></v-col
      >
    </v-row>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Lead from '@/modules/lead/LeadEditForm.vue'
import utils from '@/plugins/utils.js'
import AutocompleteProduct from '@/components/basic/input/AutocompleteProduct.vue'
import _ from 'lodash'
export default {
  components: { Lead, AutocompleteProduct },
  props: {
    lead: Object,
  },
  created() {
    this.refresh()
  },
  data() {
    return {
      loading: false,
      singleSelect: false,
      newProduct: null,
      dialog: false,
      headers: [
        {
          text: 'Mã Sản Phẩm',
          align: 'start',
          sortable: false,
          value: 'code',
        },
        { text: 'Sản Phẩm', value: 'title' },
        { text: 'Số Lượng', value: 'quantity' },
        { text: 'Giá', value: 'price' },
        { text: 'Hành Động', value: 'actions' },
      ],
      products: [],
    }
  },
  computed: {
    ...mapGetters('app', ['department']),
    ...mapGetters('auth', ['profile']),
  },
  methods: {
    ...mapActions('leads', ['updateLead']),
    addNewProduct(product) {
      this.products.push({
        ...product,
        quantity: 1,
      })
      this.newProduct = null
    },
    deleteProduct(product) {
      this.products = this.products
        .filter((p) => p.id !== product.id)
        .map((p) => ({
          ...p,
          quantity: p.quantity || 1,
        }))
    },
    refresh() {
      this.products = _.get(this.lead, 'items', []).map((p) => ({
        ...p,
        quantity: p.quantity || 1,
      }))
    },
    async save() {
      this.loading = true
      const lead = this.$refs.form.getValues()
      await this.updateLead({
        id: this.lead.id,
        ...lead,
        data: { updated: this.profile.id },
      })
      this.loading = false
    },
  },
  filters: {
    formatMoney(data) {
      return utils.formatMoney(data)
    },
  },
  watch: {
    lead() {
      this.refresh()
    },
  },
}
</script>
<style>
.oneline{
  white-space: nowrap!important;
};
</style>
